import { readStoredUserPermissions } from './userAuthorization'
import { getFirstAccessiblePath } from './userNavAccess'

/** 登录成功后的默认落点：优先回跳来源，否则按 RBAC 选首个可访问页 */
export function resolvePostLoginPath(fromPath: string | undefined): string {
  if (
    fromPath &&
    fromPath.startsWith('/') &&
    fromPath !== '/login' &&
    !fromPath.startsWith('/login/')
  ) {
    return fromPath
  }
  return getFirstAccessiblePath(readStoredUserPermissions())
}
